import { AuxiliumComponent } from "../auxilium-component";

export class Frame extends AuxiliumComponent {
	static observedAttributes = ["layout", "spacing"];

	constructor() {
		super();

		this.spacing = this.getAttribute("spacing") ?? "";
		this.layout = this.getAttribute("layout") ?? "full";
		this.restrictHeight = this.hasAttribute("restrict-height");
	}

	parsedCallback() {
		this.classList.add("layout-frame");

		if (this.restrictHeight) { this.classList.add("restrict-height"); }

		this.Header = this.querySelector("chip-frameheader");
		this.Content = this.querySelector("chip-framecontent");
		this.Sidebars = [...this.querySelectorAll("chip-framesidebar")];

		this.RightSidebar = this.querySelector("chip-framesidebar[side='right']") ?? this.Sidebars.at(1);
		this.LeftSidebar = this.querySelector("chip-framesidebar[side='left']") ?? this.Sidebars.find(x => x !== this.RightSidebar);

		switch (this.layout.toLowerCase()) {
			case "container":
				this.#BuildContainerLayout();
				break;
			case "full":
				this.#BuildFullLayout();
				break;
			case "full-centred":
				this.#BuildFullCentredLayout();
				break;
		}
	}

	#BuildFullLayout() {
		if (this.RightSidebar) { this.prepend(this.RightSidebar); }
		if (this.Content) { this.prepend(this.Content); }
		if (this.LeftSidebar) { this.prepend(this.LeftSidebar); }
		if (this.Header) { this.prepend(this.Header); }
	}

	#BuildFullCentredLayout() {
		if (this.RightSidebar) { this.prepend(this.RightSidebar); }

		if (this.Content) {
			this.Content.centred = true;

			this.prepend(this.Content);
		}

		if (this.LeftSidebar) { this.prepend(this.LeftSidebar); }
		if (this.Header) { this.prepend(this.Header); }
	}

	#BuildContainerLayout() {
		this.prepend(document.createElementWithContents("div", [this.LeftSidebar, this.Content, this.RightSidebar], {
			className: "layout-frame__content container"
		}));

		if (this.Header) {
			this.prepend(this.Header);
		}
	}
}